import React from 'react';
import { CircularProgress, Grid } from '@material-ui/core';

const Loader = ({ ...props }) => {
  return (
    <Grid container justify='center' alignItems='center' style={{ height: '100%' }}>
      <Grid item>
        <CircularProgress {...props} />
      </Grid>
    </Grid>
  )
}

export default Loader;